/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-active-input',
    templateUrl: './active-input.component.html',
    styleUrls: ['./active-input.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActiveInputComponent {
    @Input() entityName: string;
    @Input() state: boolean;
    @Output() checkState = new EventEmitter<boolean>();

    updateState(state: boolean): void {
        this.checkState.emit(state);
    }
}
